import * as React from "react";
import type { SVGProps } from "react";
const SvgLogout = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#logout_svg__a)">
      <path d="M18.16 15.84c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41L19.58 12l-2.13-2.14a.996.996 0 1 1 1.41-1.41l2.84 2.84c.39.39.39 1.02 0 1.41l-2.84 2.84c-.2.2-.45.29-.71.29zM12 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h6c2.21 0 4 1.79 4 4v2c0 .55-.45 1-1 1s-1-.45-1-1V6c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 2.21-1.79 4-4 4" />
      <path d="M21 13H9.63c-.55 0-1-.45-1-1s.45-1 1-1H21c.55 0 1 .45 1 1s-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="logout_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogout;
